// eslint-disable-next-line import/no-extraneous-dependencies
import {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft,
} from 'd3-axis';

import {
  bandScale,
  linearScale,
  timeScale,
} from './scales';

function determineOrientation(orientation) {
  let axis = null;

  switch (orientation) {
    case 'top': {
      axis = axisTop;
      break;
    }
    case 'right': {
      axis = axisRight;
      break;
    }
    case 'bottom': {
      axis = axisBottom;
      break;
    }
    case 'left': {
      axis = axisLeft;
      break;
    }
    default: {
      break;
    }
  }

  return axis;
}

export function linearAxis(config) {
  const scale = linearScale(config);
  const axis = determineOrientation(config.orientation);

  if (axis === null || !scale) {
    console.warn('no axis created!');
    return false;
  }

  return { axis, scale };
}

export function timeAxis(config) {
  const scale = timeScale(config);
  const axis = determineOrientation(config.orientation);

  if (axis === null || !scale) {
    console.warn('no axis created!');
    return false;
  }

  return { axis, scale };
}

export function bandAxis(config) {
  const scale = bandScale(config);
  const axis = determineOrientation(config.orientation);

  if (axis === null || !scale) {
    console.warn('no axis created!');
    return false;
  }

  return { axis, scale };
}
